import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import { setDownloadModalOpen } from "../../../../redux/reducers/JobExport";
import DownloadSection from "./DownloadOptions/DownloadSection";

export const DownloadModal = ({ jobType, btnVariant }) => {
  const dispatch = useDispatch();
  const { downloadModalOpen } = useSelector(
    (state: ReduxState) => state.JobExport
  );
  const toggle = () => dispatch(setDownloadModalOpen(!downloadModalOpen));

  const { steps } = useSelector((state: ReduxState) => state.OnboardingSteps);

  const animate = steps.filter(
    (s) => s.name === "DOWNLOAD_DATA" && !s.completed
  );

  return (
    <>
      <Button
        className="btn--download-data"
        variant={btnVariant}
        onClick={toggle}
        style={
          animate.length > 0
            ? {
                boxShadow: "0 0 15px rgba(0,123,255,0.5)",
                transform: "scale(1.05)",
                transition: "all 0.3s ease",
                fontWeight: "bold",
                animation: "pulse 1.5s infinite",
              }
            : {}
        }
      >
        <style>
          {`
            @keyframes pulse {
              0% {
                box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.7);
              }
              70% {
                box-shadow: 0 0 0 8px rgba(0, 123, 255, 0);
              }
              100% {
                box-shadow: 0 0 0 0 rgba(0, 123, 255, 0);
              }
            }
          `}
        </style>
        <FontAwesomeIcon icon="download" />
        <span className="ml-1">Download Data</span>
      </Button>

      <Modal size="lg" show={downloadModalOpen} onHide={toggle}>
        <Modal.Header
          closeButton
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
          placeholder=""
        >
          <Modal.Title>Download Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DownloadSection jobType={jobType} />
        </Modal.Body>
      </Modal>
    </>
  );
};
